import React from 'react';
import classNames from 'classnames';

import Link from '../Link';
import Image from '../Image';
import RenderStaticHTML from '../RenderStaticHTML';

import { useAddKeyProp } from '../../utils/hooks';

const ns = `nav-sub-menu`;

/**
 * List of menu items.
 */
const NavSubMenu = ({
	menuItems = [],
	navigationText,
	active,
	onMouseEnter,
	onMouseLeave,
	onClick,
	className,
	setSubMenuRef,
	// currentPathname,
}) => {
	const keyedMenuItems = useAddKeyProp(menuItems, 'burnham');

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ ns }--active`]: active,
		[`${ className }`]: !!className,
	});

	return (
		<div
			ref={setSubMenuRef}
			className={rootClassnames}
			onMouseEnter={() => {
				(typeof onMouseEnter === 'function' && onMouseEnter());
			}}
			onMouseLeave={() => {
				(typeof onMouseLeave === 'function' && onMouseLeave());
			}}

		>
			{
				keyedMenuItems
					&& (
						<div className={`container`}>
							<div className={`${ ns }__content`}>
								{
									keyedMenuItems.map(column => {
										// const activeLink = item.url === currentPathname;

										return (
											<div key={column.key} className={`${ ns }__column`}>
												{column?.type === 'list' && (
													<ListColumn
														column={column.listColumn}
														onClick={onClick}
														onMouseLeave={onMouseLeave}
													/>
												)}
												{column?.type === 'featured' && (
													<FeaturedColumn
														column={column.featuredColumn}
														onClick={onClick}
														onMouseLeave={onMouseLeave}
													/>
												)}
											</div>
										);
									})
								}
							</div>
							{navigationText && (
								<div className={`${ ns }__footer`}>
									<RenderStaticHTML html={navigationText} />
								</div>
							)}
						</div>
					)
			}
		</div>
	);
};

export default NavSubMenu;

// Column with image thumbnail

function FeaturedColumn({ column, onClick, onMouseLeave }) {
	const {
		image,
		link,
	} = column;

	return (
		<div className={`${ ns }__column-featured`}>
			<Link
				className={`underline-child-on-hover`}
				to={link?.url}
				onClick={() => {
					(typeof onMouseLeave === 'function' && onMouseLeave());
					(typeof onClick === 'function' && onClick());
				}}
			>
				<div className={`${ ns }__column-featured-media`}>
					<Image dataMedia {...image} />
				</div>
				<p className={`underline-child`}>{link?.label}</p>
			</Link>
		</div>
	);
}

// Column with unordered list

function ListColumn({ column = [], onClick, onMouseLeave }) {
	if (column?.length < 0) return null;

	return (
		<ul className={`${ ns }__column-list`}>
			{column.map(({ link }) => {
				return (
					<li key={link?.label} className={`underline-child-on-hover`}>
						<Link
							className={`underline-child`}
							to={link?.url}
							onClick={() => {
								(typeof onMouseLeave === 'function' && onMouseLeave());
								(typeof onClick === 'function' && onClick());
							}}
						>
							{ link?.label }
						</Link>
					</li>
				);
			})}
		</ul>
	);
}
